export default {
  name: 'uim',
  decorateRequest(request) {
    const requestOptions = request.requestOptions || {};
    requestOptions.headers = request.requestOptions.headers || {};
    requestOptions.headers.Authorization = request.token.startsWith('Bearer ')
      ? request.token
      : `Bearer ${request.token}`;
    return requestOptions;
  },
  validTokenForRequest(token) {
    try {
      const payload = token.replace('Bearer ', '').split('.')[1];
      const expirationTime = parseInt(JSON.parse(atob(payload)).exp, 10) * 1000;
      if (expirationTime - 6000 > Date.now()) {
        return true;
      }
      return false;
    } catch (ex) {
      return false;
    }
  },
  responseSignalsTokenRefresh(response) {
    return response.status === 401;
  },
};
